import React from "react";
import { Modal } from "antd";
import { useForm } from "react-hook-form";
import { useMutation, queryCache } from "react-query";
import { TInput } from "../form/Field/TInput";
import { apiAxios } from "services/HttpServices";
import { NotificationStateContext } from "context/UI/Notification/NotificationState";

const createFinishing = async (finishing) => {
  try {
    const res = await apiAxios.post(`/jobs/finishings`, finishing);
    return res.data.data;
  } catch (e) {
    throw e.response.data.message;
  }
};

function AddFinishingModal(props) {
  const { visible, handleClose, setNewFinishingId } = props;
  const [error, setError] = React.useState(null);
  const {
    state: notificationState,
    setLoading,
    finishLoading,
  } = React.useContext(NotificationStateContext);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      name: "",
    },
  });
  // const onSubmit = (data) => {
  //   console.log(data);
  // };

  const onSubmit = async (data) => {
    setError("");
    setLoading("createFinishing");
    try {
      await mutateFinishings(data);
      finishLoading("createFinishing");
    } catch (error) {
      finishLoading("createFinishing");
      reset();
    }
  };

  //Mutation
  const [mutateFinishings] = useMutation(createFinishing, {
    onSuccess: (newFinishing) => {
      queryCache.setQueryData(["finishings"], function (oldData) {
        return [newFinishing, ...oldData];
      });
      setNewFinishingId(newFinishing.id);
      reset();
      handleClose();
    },
    onError: (e) => {
      setError(e);
    },
  });

  return (
    <Modal
      title="Add new finishing"
      visible={visible}
      onCancel={() => handleClose()}
      onOk={handleSubmit(onSubmit)}
      confirmLoading={notificationState.loading.createFinishing}
      destroyOnClose
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <TInput
          label="Finishing Name*"
          name="name"
          placeholder="Name"
          autoFocus={true}
          propsInput={{
            control: control,
          }}
        />
      </form>
    </Modal>
  );
}

export default AddFinishingModal;
